import { useState, useRef } from 'react';
import styled from 'styled-components';

import {TextField, Typography, Box, InputAdornment} from '@mui/material';

import Label from './label';

import { colors } from '../../theme';
import {ReactComponent as SearchIcon} from "../../assets/icons/search-icon.svg";

interface InputProps {
    table: string;
    changecolor: any;
}

const GlobalInput = (props: any) => {
    const { value, name, label, center, type, onChange, parse, id: dataItemKey, changecolor, onColorChange, isTime } = props;
    const oldValueRef = useRef('');
    const [resetValue, setResetValue] = useState(false);

    const handleTime = (name: string, value: any) => {
        const oldValue = oldValueRef.current;
        const onlyNumber = /^[0-9 ]+$/;
        let replaced = value.replaceAll('—', '').replaceAll(':', '').replaceAll(' ', '');
        if ('' !== value && !onlyNumber.test(replaced)) return;
        if (value.length < oldValue.length && oldValue.slice(-1) === ':') replaced = '';

        let firstDigit = parseInt(replaced.slice(0, 1));
        let secondDigit = parseInt(replaced.slice(1, 2));
        let thirdDigit = parseInt(replaced.slice(2, 3));

        if (replaced.length < 4) {
            if (parseInt(replaced[0]) > 23) {
                //reset when more than 4 digits
                replaced = replaced[replaced.length - 1];

                //keep 4 digits
                return;
            }
            if (typeof replaced === 'string' && replaced.startsWith('0')) {
                return;
            }
            if ((firstDigit != 1 && parseInt(replaced.substring(1)) > 59) || (firstDigit == 1 && secondDigit >= 6 && thirdDigit >= 6)) {
                //reset when more than 4 digits
                replaced = replaced[replaced.length - 1];

                //keep 4 digits
                return;
            }
        } else if (replaced.length === 4) {
            if (parseInt(replaced.substring(0, 2)) > 23) {
                //reset when more than 4 digits
                replaced = replaced[replaced.length - 1];

                //keep 4 digits
                return;
            }
            if (replaced.substring(2) > 59) {
                //reset when more than 4 digits
                replaced = replaced[replaced.length - 1];

                //keep 4 digits
                return;
            }
        } else if (replaced.length > 4) {
            //reset when more than 4 digits
            replaced = replaced[4];

            //keep 4 digits
            // replaced = replaced.slice(0, 4);
            // if (parseInt(replaced.substring(0, 2)) > 23) return;
            // if (replaced.substring(2) > 59) return;
        }

        let newValue = '';


        // Cater for scenarios where entry is 170 (for 1700)
        if (replaced.length === 3 && firstDigit === 1 && secondDigit >= 6) {
            newValue = [replaced.slice(0, 2), ':', replaced.slice(2)].join('');
        } else if (0 < replaced.length && replaced.length < 4) {
            newValue = [replaced.slice(0, 1), ':', replaced.slice(1)].join('');
        } else if (replaced.length === 4) {
            newValue = [replaced.slice(0, 2), ':', replaced.slice(2)].join('');
        }

        oldValueRef.current = newValue;
        onChange(name, newValue);
    };

    return (
        <Box sx={{ display: 'flex', alignItems: props.multiline ? 'flex-start' : 'center', maxWidth: '100%', justifyContent: center && 'center' }}>
            {label && <Label {...props} />}
            {/*{type === 'currency' && <CurrencyLabel>$</CurrencyLabel>}*/}
            <StyledTextField
                {...props}
                id={dataItemKey}
                type={type === 'currency' ? 'number' : type}
                parse={parse}
                name={name}
                center={center}
                label={''}
                // value={resetValue ? '' : type !== 'number' ? value || '' : value}
                fullWidth
                changecolor={changecolor && changecolor === dataItemKey}
                onClick={onColorChange}
                InputProps={{
                    ...props.InputProps,
                    startAdornment: (() => {
                        if (type === 'currency') {
                            return (
                                <InputAdornment position="start">
                                    $
                                </InputAdornment>
                            );
                        } else if (type === 'search') {
                            return (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            );
                        } else {
                            return null;
                        }
                    })(),
                }}
                inputProps={{ ...props.inputProps }}
                onChange={(e) => {
                    const { target: { name, value } } = e;

                    setResetValue(false);

                    if (type === 'number') {
                        if (parse === 'float') onChange(name, parseFloat(value));
                        if (parse === 'int') onChange(name, parseInt(value));
                    } else if (isTime) {
                        handleTime(name, value);
                    } else {
                        onChange(name, value);
                    }
                }}
                onFocus={() => {
                    if (isTime && (value === '00:00' || value === '23:59')) setResetValue(true);
                }}
                onBlur={() => {
                    if (isTime && (value === '00:00' || value === '23:59')) setResetValue(false);
                }}
            />
        </Box>
    );
};

export default GlobalInput;

const StyledTextField = styled(TextField) <InputProps>`
    && {
        & .MuiOutlinedInput-root {
            max-height: ${(props) => !props.multiline && '28px'};
            color: ${(props) => (props.table === 'true' && !props.changecolor ? colors.black : colors.blue.main)};
            background-color: ${colors.white};
            display: flex;
            // max-width: ${(props) => props.table && '150px'};
            padding: ${(props) => props.multiline && '5px 15px'};

            ${(props) => props.table === 'true' && { fontSize: '12px' }}
            & fieldset {
                border-color: ${colors.border};
            }

            &:hover fieldset {
                border-color: ${colors.blue.main};
                border-width: 1px;
            }

            &.Mui-focused fieldset {
                border-color: ${colors.blue.main};
                border-width: 1px;
                color: ${colors.blue.main};
            }

            &.Mui-disabled fieldset {
                border-color: ${colors.border};
            }
        }
    }
`;

const CurrencyLabel = styled.div`
    color: black;
    font-size: 12px;
    font-weight: 700;
    margin-right: 2px;
`
